module.exports = __webpack_public_path__ + "img/checkmark-circle-outline.e38dd0d3.svg";